import ConfigParameter, {gettext} from "../ConfigParameter";

export default class Video extends ConfigParameter {


    constructor() {
        let model = {
            videoId: '',
            data: '',
            videoType: '',
            url: ''
        };

        super('video', 'video', gettext('Video URL'), 'mainConfig', model, null, null, null, null, gettext('Only videos from Youtube and Vimeo are supported.'));
    }
}



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/Video.js